<script setup>
defineProps({
  title: { type: String, default: 'Construisons votre dispositif médical préventif.' },
  description: { type: String, default: 'Nous vous répondons rapidement pour cadrer vos besoins événementiels: effectifs, moyens mobiles, poste de soins et coordination opérationnelle.' },
})
</script>

<template>
  <section
    id="contact"
    class="public-content"
  >
    <div class="mx-auto max-w-7xl px-6 md:px-12 xl:px-6">
      <div class="public-section grid gap-8 p-6 md:grid-cols-2 md:gap-12 md:p-10 lg:p-12">
        <div>
          <p class="mb-3 text-sm font-semibold text-brand-blue-700 dark:text-brand-blue-300">
            Contact direct
          </p>
          <h2 class="public-h2">
            {{ title }}
          </h2>
          <p class="public-lead mt-4">
            {{ description }}
          </p>

          <dl class="mt-8 space-y-4">
            <div class="border-t border-[var(--line-soft)] pt-4">
              <dt class="public-muted text-sm font-semibold">
                Adresse
              </dt>
              <dd class="mt-1 text-sm text-[var(--ink-900)]">
                Quatrième Rue 33, 6040 Jumet, Belgique
              </dd>
            </div>
            <div class="border-t border-[var(--line-soft)] pt-4">
              <dt class="public-muted text-sm font-semibold">
                Informations légales
              </dt>
              <dd class="mt-1 text-sm text-[var(--ink-900)]">
                BCE: BE 0637 949 895 · Agrément: RW180
              </dd>
            </div>
          </dl>
        </div>

        <div class="md:border-l md:border-[var(--line-soft)] md:pl-12">
          <h3 class="public-h3 text-2xl">
            Nos coordonnées
          </h3>

          <dl class="mt-6 space-y-5">
            <div>
              <dt class="public-muted text-sm font-semibold">
                Email
              </dt>
              <dd class="mt-1 text-base text-[var(--ink-900)] wrap-break-word">
                info@ambulancepresentasbl.be
              </dd>
            </div>
            <div>
              <dt class="public-muted text-sm font-semibold">
                Téléphone
              </dt>
              <dd class="mt-1 text-base text-[var(--ink-900)] wrap-break-word">
                +32 474 03 55 48
              </dd>
            </div>
            <div>
              <dt class="public-muted text-sm font-semibold">
                Compte bancaire
              </dt>
              <dd class="mt-1 text-base text-[var(--ink-900)] wrap-break-word">
                BE04 7320 3760 4931
              </dd>
            </div>
          </dl>

          <div
            class="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap"
            data-track-zone="contact_card"
          >
            <UButton
              to="/contact"
              size="lg"
              label="Nous contacter"
              class="justify-center"
            />
            <UButton
              to="/devis"
              variant="outline"
              size="lg"
              label="Demander un devis"
              class="justify-center"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
